import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    rgb: String 
  }

  toggle(event) {
    event.preventDefault()
    
    // Dispatch custom event that React component will listen to
    const highlightEvent = new CustomEvent("processing-result:highlight-color", {
      detail: { rgb: this.rgbValue },
      bubbles: true
    })
    document.dispatchEvent(highlightEvent)
    
    // Toggle active state for visual feedback in the list
    this.element.classList.toggle("bg-warning", !this.element.classList.contains("bg-warning"))
    this.element.classList.toggle("border-warning", !this.element.classList.contains("border-warning"))
    
    // Clear other highlighted items in the same list
    const otherActiveItems = this.element.closest('.list-group').querySelectorAll('.list-group-item.bg-warning')
    otherActiveItems.forEach(item => {
      if (item !== this.element) {
        item.classList.remove("bg-warning", "border-warning")
      }
    })
  }
}
